
import React from "react";
import Btn from "../common/Btn";
import EventItem from "../common/EventItem";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHead from "../common/SectionHead";
import styles from "../../assets/style.module.css";
import { IWebsiteEvent } from "../../../../../services";

export interface EventsAccordionProps {
    basePath: string;
    events: IWebsiteEvent[];
}

function EventsAccordion({ basePath, events }: EventsAccordionProps) {

    const labels = i18nManager.Labels.home;
    const [open, setOpen] = React.useState<number>(0);

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHead align="center" tag={labels.events} title={labels.events_title} />
            <div className={styles["acc-list"]}>
                {events.map((ev, i) => (<EventItem key={ev.external_id} index={i} event={ev} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />))}
            </div>
            <div className={styles["center-row"]}>
                <Btn variant="outline" size="sm" to={pagePath(basePath, "EVENTS")}>{i18nManager.Labels.view_all}</Btn>
            </div>
        </div>
    </section>);
}

export default EventsAccordion;
